import { NgModule, } from '@angular/core';
import { EmptyTextDirective } from './empty-text.directive';
import { EmptyTextService } from './empty-text.service';

import { jqxButtonComponent } from 'jqwidgets-framework/jqwidgets-ts/angular_jqxbuttons';

@NgModule({
    imports: [],
    exports: [EmptyTextDirective,jqxButtonComponent],
    declarations: [EmptyTextDirective,jqxButtonComponent],
    providers: [EmptyTextService],
})
export class EmptyTextModule { }
